import { gql } from "@apollo/client";

export default gql`
	mutation ($receipt: String, $key: String!) {
		requestDirectOrderLinkToken(receipt: $receipt, key: $key)
	}
`;
